import { render, staticRenderFns } from "./CertificateSearch.vue?vue&type=template&id=e9d84804&scoped=true"
import script from "./CertificateSearch.vue?vue&type=script&lang=js"
export * from "./CertificateSearch.vue?vue&type=script&lang=js"
import style0 from "./CertificateSearch.vue?vue&type=style&index=0&id=e9d84804&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9d84804",
  null
  
)

export default component.exports